import React, { Component } from "react";

class AboutTwo extends Component {
    render() {
        let title = 'About'
        return (
            <React.Fragment>
                <div className="about-wrapper">
                    <div className="container">
                        <div className="row row--35 align-items-center">

                            <div className="col-lg-5 col-md-12">
                                <div className="thumbnail">
                                    <img className="w-100" src="/assets/images/about/about.jpg" alt="About Lovit Bathware" />
                                </div>
                            </div>

                            <div className="col-lg-7 col-md-12">
                                <div className="about-inner inner">
                                    <div className="section-title">
                                        <h2 className="title">{title}</h2>
                                        <p className="description">Welcome to lovit where creativity and craftsmanship collide
                                            to transform spaces into works of art. We're not just your
                                            average sanitary ware company - we're your partners in
                                            design, yourpurveyors ofpanache, and yourgo-to gurus forall
                                            things sanitery -tastic!</p>
                                    </div>
                                    <div className="row mt--30 mt_sm--10">
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                            <div className="about-us-list">
                                                <h3 className="title">Who we are</h3>
                                                <p>Our journey started with a spark of imagination and a
                                                    truckload of passion for redening spaces. At lovit, we're not
                                                    just in the business of selling sanitary ware; we're in the
                                                    business of curating experiences. With a dash of innovation
                                                    and a sprinkle of eccentricity, we've been shaking up the
                                                    sanitary ware scene foryears.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default AboutTwo;